import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';

@Component({
    selector: 'app-nav-evaluation',
    templateUrl: './nav-evaluation.component.html',
    styleUrls: ['./nav-evaluation.component.css'],
    standalone: false
})
export class NavEvaluationComponent implements OnInit {
  url: string;
  Evaluation: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  MsgType: number;
  DisplayMessage: string;
  FormSearchPlanDiary: FormGroup;
  advanceSearchValue: any;
  pageNumber: number;
  RightsID: string;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder) {
    this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.pageNumber = 1;
    this.MsgType = 1; // Loading
    this.advanceSearchValue = "";
    this.GetEvaluationData();
  }
  OpenModal(url, cID, ContextType, returnFunction)    {
    this.modalURL =  url +"/" + cID;
    this.CallFunctionOnCloseModal = returnFunction;
    this.ModelFor = ContextType;
  }
  ReturnAdvanceSearch() {
   // if (localStorage.getItem('advancesearch') != "") {
   // this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch')); }
   // localStorage.setItem('advancesearch', "");
    
   this.GetEvaluationData();
    this.modalURL = '';
  }
  receiveMessage(event) {

    localStorage.setItem('advancesearch', event.data.data.Param);
    let element: HTMLElement;
    element = document.getElementsByClassName('close')[0] as HTMLElement;
    element.click();
  }
  GetEvaluationData()
  {
    this.modalURL = '';
    this.http.get(this.url + 'EvalForm/FetchEvaluationStructure')
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          alert(data);
          this.Evaluation = null;
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
         } else {
          this.MsgType = 0; // No Message
          this.Evaluation = JSON.parse(data.toString()); }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
         this.Evaluation = null;
       }
    );
  }
}
